import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/escola" element={<LandingPage isSchoolRoute={true} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
